module.exports = __webpack_public_path__ + "img/banner_hk.28afc273.jpg";